import { ArrowBack } from "@mui/icons-material";
import { Box, Button, Stack, useMediaQuery, useTheme } from "@mui/material";
import { ConsentContext } from "./provider.js";
import { ConsentInternalApiContext } from "./internal-api.js";
import { DetailGroup } from "./detail-group.js";
import { useTranslation } from "next-i18next";
import React from "react";
export const Details = ({ changeView }) => {
    const { t } = useTranslation("c-user-consent-management");
    const theme = useTheme();
    const isAtLeastSm = useMediaQuery(theme.breakpoints.up("sm"));
    const { closePreferences, groups, processes } = React.useContext(ConsentContext);
    const { save } = React.useContext(ConsentInternalApiContext);
    const acceptSettings = () => {
        save();
        closePreferences();
    };
    const acceptAllProcesses = () => {
        save(processes.map(({ id }) => ({ id })));
        closePreferences();
    };
    return (React.createElement(Box, null,
        React.createElement(Stack, { component: "ul", direction: "column", spacing: 2, sx: { listStyleType: "none", p: 0, pl: 0, mt: 0 } }, groups.map((group) => (React.createElement(DetailGroup, { key: `details-group-${group.id}`, group: group })))),
        React.createElement(Stack, { alignItems: "center", direction: { xs: "column", sm: "row" }, justifyContent: "flex-end", spacing: { xs: 1, sm: 0 }, sx: {
                backgroundColor: { xs: "white", sm: "unset" },
                borderTop: { xs: `1px solid ${theme.palette.divider}`, sm: "unset" },
                bottom: 0,
                left: 0,
                pb: { xs: 2, sm: 0 },
                position: { xs: "sticky", sm: "relative" },
                pt: { xs: 1.5, sm: 6 },
            } },
            React.createElement(Button, { color: isAtLeastSm ? "secondary" : "primary", sx: { width: { xs: "100%", md: "unset" } }, startIcon: React.createElement(ArrowBack, null), size: "small", onClick: () => changeView("overview"), variant: "text" }, t("back", "Zurück")),
            React.createElement(Button, { color: isAtLeastSm ? "secondary" : "primary", sx: { width: { xs: "100%", md: "unset" } }, variant: isAtLeastSm ? "text" : "outlined", size: "small", onClick: acceptSettings }, t("save", "Speichern")),
            React.createElement(Button, { autoFocus: true, color: isAtLeastSm ? "secondary" : "primary", onClick: acceptAllProcesses, size: "small", sx: { width: { xs: "100%", md: "unset" }, ml: { xs: 0, sm: 3 } }, variant: "contained" }, t("accept-all", "Alle akzeptieren")))));
};
//# sourceMappingURL=details.js.map